import * as fetchJsonp from 'fetch-jsonp';
import { v4 } from 'uuid';

import { config } from './config';

export const call = (params) => {
  const url = new URL(`${config.apiLocation}/AddCustomer`);

  // Default params
  url.searchParams.set('PublicKey', config.publicKey);
  url.searchParams.set('SmsPaymentReminder ', 'N');
  url.searchParams.set('ContractStartDate', new Date().toISOString().split('T')[0]);
  url.searchParams.set('SmsFailedNotification', 'N');
  url.searchParams.set('SmsExpiredCard', 'N');
  url.searchParams.set('YourSystemReference', v4());

  for (let key in params) {
    url.searchParams.set(key, params[key]);
  }

  // Call api
  return fetchJsonp(url.toString(), { timeout: 30000 })
    .then(res => res.json())
    .then(data => {
      if (data.Error !== 0) {
        throw new Error(`${data.Error}: ${data.ErrorMessage}`);
      }

      return data.Data.CustomerRef;
    });
}



// WEBPACK FOOTER //
// ./lib/ezidebit/call.ts